import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { DATE_INPUT_ID } from '../../../constants/formFields'
import FadeAndCollapse from '../../../shared/components/FadeAndCollapse'
import DateInput from '../../shared/DateInput'
import SSNInput from '../../shared/SSNInput'
import NamesInput from '../../shared/NamesInput'
import TextInputError from '../../shared/TextInputError'
import Address from './Address'
import { Label, P3 } from '../../../shared/compass-ui'
import useFormStore from '../../../shared/hooks/useFormStore'

const PersonalInformation = () => {
  const {
    formState: { errors },
  } = useFormContext()
  const { dateOfBirth: dateOfBirthError, socialSecurityNumber: socialSecurityNumberError } = errors
  const [showHelperText, setShowHelperText] = useState<boolean>(false)

  const [formStore] = useFormStore()
  const { isMulticardFlow } = formStore

  return (
    <div className="flex flex-col gap-y-6">
      <NamesInput />
      <div className="grid grid-cols-4 md:grid-cols-6 gap-6">
        <div className="col-span-full md:col-span-3">
          <Label htmlFor={DATE_INPUT_ID}>Date of Birth</Label>
          <DateInput error={dateOfBirthError} readOnly={isMulticardFlow} autoComplete="bday" />
        </div>
        <div className="col-span-full md:col-span-3">
          <Label htmlFor="ssn-input">SSN or ITIN</Label>
          <SSNInput
            error={typeof socialSecurityNumberError?.message === 'string'}
            onBlur={() => setShowHelperText(false)}
            onFocus={() => setShowHelperText(true)}
          />
          {typeof socialSecurityNumberError?.message === 'string' && (
            <TextInputError>{socialSecurityNumberError.message}</TextInputError>
          )}
          <FadeAndCollapse show={showHelperText}>
            <P3 className="mt-2">
              <b className="text-ink-800">
                Please double-check your Social Security Number (SSN) or Individual Taxpayer
                Identification Number (ITIN) before submitting.
              </b>{' '}
              An incorrect entry could result in your application being declined.
            </P3>
          </FadeAndCollapse>
        </div>
      </div>
      <Address />
    </div>
  )
}
export default PersonalInformation
